var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMerchantIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 75.429,
    height: 70.321,
    viewBox: "0 0 75.429 70.321",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3568",
    "data-name": "Rectangle 3568",
    width: 75.429,
    height: 70.321,
    fill: "#e0186a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10203",
    "data-name": "Group 10203",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10202",
    "data-name": "Group 10202",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32409",
    "data-name": "Path 32409",
    d: "M7.952,68.887A7.969,7.969,0,0,1,0,60.937v-5.6a7.954,7.954,0,0,1,15.9,0v5.6a7.967,7.967,0,0,1-7.95,7.95m0-16.957a3.416,3.416,0,0,0-3.416,3.406v5.6a3.407,3.407,0,0,0,6.815,0v-5.6a3.4,3.4,0,0,0-3.4-3.414ZM27.8,68.887a7.959,7.959,0,0,1-7.952-7.95V46.25a7.954,7.954,0,0,1,15.9,0V60.937a7.967,7.967,0,0,1-7.95,7.95m0-26.044A3.41,3.41,0,0,0,24.38,46.25V60.937a3.407,3.407,0,0,0,6.815,0V46.25a3.412,3.412,0,0,0-3.4-3.414ZM47.633,68.887a7.966,7.966,0,0,1-7.95-7.95V37.163a7.954,7.954,0,0,1,15.9,0V60.937a7.969,7.969,0,0,1-7.952,7.95m0-35.13a3.414,3.414,0,0,0-3.414,3.406V60.937a3.407,3.407,0,0,0,6.815,0V37.163a3.4,3.4,0,0,0-3.4-3.414Zm19.845,35.13a7.957,7.957,0,0,1-7.95-7.95V28.077a7.954,7.954,0,0,1,15.9,0V60.937a7.969,7.969,0,0,1-7.952,7.95m0-44.217a3.41,3.41,0,0,0-3.414,3.406V60.937a3.407,3.407,0,0,0,6.815,0V28.077a3.409,3.409,0,0,0-3.4-3.414ZM8.551,34.363A2.272,2.272,0,0,1,7.423,30.12L57.493,1.732a2.272,2.272,0,1,1,2.239,3.952L9.662,34.064a2.208,2.208,0,0,1-1.111.3",
    transform: "translate(0 1.434)",
    fill: "#e0186a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32410",
    "data-name": "Path 32410",
    d: "M35.406,7.411a2.267,2.267,0,0,1-.606-.079L24.412,4.452A2.271,2.271,0,0,1,25.619.075L36.014,2.954a2.27,2.27,0,0,1-.608,4.456",
    transform: "translate(23.213 0)",
    fill: "#e0186a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32411",
    "data-name": "Path 32411",
    d: "M28.759,16.368a2.254,2.254,0,0,1-1.815-.89,2.283,2.283,0,0,1-.378-1.981L29.443,3.1a2.272,2.272,0,1,1,4.378,1.216L30.943,14.7a2.27,2.27,0,0,1-2.185,1.664",
    transform: "translate(26.992 1.43)",
    fill: "#e0186a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMerchantIcon3);
export default __webpack_public_path__ + "static/media/merchant-icon3.6fafa766d2da29a163f6f57763b3aadd.svg";
export { ForwardRef as ReactComponent };